import { Component, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';

import { TemplateDialogButtonBase } from '../../shared/base/template-dialog-button-base';
import { Lecture } from '../shared/lecture';

@Component({
  selector: 'app-lecture-members-button',
  templateUrl: './lecture-members-button.component.html'
})
export class LectureMembersButtonComponent extends TemplateDialogButtonBase {
  @Input() lecture: Lecture;

  constructor(dialog: MatDialog, snackBar: MatSnackBar) {
    super(dialog, snackBar);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-members-button/lecture-members-button.component.ts